export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        init() {
            console.info('m-audiences initialized.')
        }
    }
}
